import { useCallback, useEffect, useRef, useState } from 'react';
import { useSwipeGesture } from '@repo/ui';
export function useParkingPhotosOverlay({ images, isOpen, initialIndex = 0, }) {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);
    const thumbnailsRef = useRef([]);
    const currentImage = images[currentIndex];
    const handleNext = useCallback(() => {
        if (images.length <= 1)
            return;
        setCurrentIndex((prev) => (prev + 1) % images.length);
    }, [images.length]);
    const handlePrev = useCallback(() => {
        if (images.length <= 1)
            return;
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    }, [images.length]);
    const { swipeRef } = useSwipeGesture({
        onSwipeLeft: handleNext,
        onSwipeRight: handlePrev,
    });
    useEffect(() => {
        if (isOpen) {
            setCurrentIndex(initialIndex);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen, initialIndex]);
    useEffect(() => {
        const activeThumb = thumbnailsRef.current[currentIndex];
        if (activeThumb) {
            activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }, [currentIndex]);
    const handleThumbnailClick = useCallback((index) => {
        setCurrentIndex(index);
    }, []);
    return {
        currentIndex,
        currentImage,
        thumbnailsRef,
        swipeRef,
        handleNext,
        handlePrev,
        handleThumbnailClick,
    };
}
